import { Card, Flex, Typography } from 'antd'
import React from 'react'
import { useAuth } from '../../auth'
import { useTranslation } from 'react-i18next'

export function PaymentCard() {
    const { activeCompany } = useAuth()
    const { t } = useTranslation()

    return (
        <Card className="w-full">
            <Typography.Text type="secondary">{t('Payment method')}</Typography.Text>
            <Flex
                justify="space-between"
                className="mt-2"
            >
                <Typography.Title
                    level={3}
                    className="min-w-44"
                >
                    {activeCompany?.pmType}
                </Typography.Title>
                <Typography.Paragraph type="secondary">
                    {'**** **** ****'} {activeCompany?.pmLastFour}
                    <br />
                    {activeCompany?.name}
                </Typography.Paragraph>
            </Flex>
        </Card>
    )
}
